/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import Icon from 'components/core/icon';

export const adminAccessRoles = ['Soundtalks Customer Support', 'Spectator User'];

export const integratorImportAccessRoles = ['Integrator Import Admin'];

// Alert rule writes (create/rename/archive/new version) are CS-staff-only on the backend;
// Spectator User can view but not write. See docs/alert-rules-backend-requests.md.
export const alertRuleWriteAccessRoles = ['Soundtalks Customer Support'];

export const dropZones = [
  {
    label: 'nursery',
    value: 'Nursery',
    icon: Icon.icons.nursery,
  },
  {
    label: 'fattening',
    value: 'Fattening',
    icon: Icon.icons.fattening,
  },
  {
    label: 'wean to finish',
    value: 'Wean to finish',
    icon: Icon.icons.weanToFinish,
  },
  {
    label: 'Boar',
    value: 'Boars',
    icon: Icon.icons.boar,
  },
  {
    label: 'Gilt',
    value: 'Gilt',
    icon: Icon.icons.gilt,
  },
];
